import React from "react"

interface HighlightedTextProps {
  text: string
  searchText: string
  isCurrentMatch: boolean
  className?: string
}

/**
 * Highlights all occurrences of searchText in text, with special highlighting for currentMatch
 */
export const HighlightedText: React.FC<HighlightedTextProps> = ({
  text,
  searchText,
  isCurrentMatch,
  className = "",
}) => {
  if (!searchText.trim()) {
    return <span className={className}>{text}</span>
  }

  // Escape special regex characters in searchText
  const escapedSearchText = searchText.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
  const regex = new RegExp(`(${escapedSearchText})`, "gi")
  const parts = text.split(regex)

  return (
    <span className={className}>
      {parts.map((part, index) => {
        // Check if this part matches the search text (case-insensitive)
        // Use a regex to handle case-insensitive comparison
        const matchRegex = new RegExp(`^${escapedSearchText}$`, "i")
        if (matchRegex.test(part)) {
          // This is a match
          return (
            <mark
              key={index}
              className={
                isCurrentMatch
                  ? "bg-yellow-400 dark:bg-yellow-500 font-semibold"
                  : "bg-yellow-200 dark:bg-yellow-700"
              }
            >
              {part}
            </mark>
          )
        }
        return <React.Fragment key={index}>{part}</React.Fragment>
      })}
    </span>
  )
}
